// 根据后端返回的 code 码，处理不同的业务
import * as code from '@/constant/request'
import handleNotAddWechat from './handleNotAddWechat'

export default {
  [code.NOT_ADD_WECHAT]: handleNotAddWechat,
}
